import React, {Component, PropTypes} from 'react';
import {lang} from '../../strings';
import {format} from '../../utils/string';
import {formatDate} from '../../utils/date';

export default class InvoiceAddress extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let {invoiceAddress} = this.props;

        return (
            <div key={invoiceAddress.id} className="mp-block-half">
                <div className="" style={{marginBottom: 20}}>
                    <strong>{lang.customer.customerNumber}: {invoiceAddress.customerNumber}</strong><br />
                    {invoiceAddress.careOf} <br />
                    {invoiceAddress.addressLine1} <br />
                    {invoiceAddress.postCode} {invoiceAddress.area}

                    {invoiceAddress.hasActiveAddressChangeTask ?
                        <p className="mp-task-info">{format(lang.customer.tasks.addressChange, invoiceAddress.task.newAddress, formatDate(invoiceAddress.task.activationDate, 'LL'))}</p> : null}
                </div>
            </div>
        );
    }
}

InvoiceAddress.propTypes = {
    invoiceAddress: PropTypes.object.isRequired
};